import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_fragrances_sages: FaireCategoryEntity = {
  token: "cat_fragrances-sages",
  type: "category",
  name: "Sages & smudges",
  level: 3,
  parentToken: "cat_home-decor-fragrances",
  href: "/category/home-decor/home-fragrances/sages-smudges",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
